import { FeatureFlag } from '../FeatureFlag';

/**
 * Renders the Results widget (AskAlphaList) through the new owned grid (`TableModelViewer`,
 * ADR 0014) instead of the ag-grid `ColumnTemplateTableViewer`.
 *
 * Deliberately scoped to the Results widget only: the grid replacement rolls out one usage at a
 * time behind fine-grained flags, so a regression in one widget can be flipped off without
 * touching the others.
 */
export const enableNewResultsGrid = new FeatureFlag({
    key: 'enable-new-results-grid',
    defaultValue: false,
});
